/* assets/custom.js */
document.addEventListener('DOMContentLoaded', () => {
  const discountBar = document.querySelector('.discount-bar');
  if (discountBar && discountBar.parentNode !== document.body) {
    // wstaw tuż przed pierwszym dzieckiem <body>
    document.body.insertBefore(discountBar, document.body.firstChild);
  }
});
